export const GET_OPERATING_TOURS_LIST_START="GET_OPERATING_TOURS_LIST_START"
export const GET_OPERATING_TOURS_LIST_SUCCESS="GET_OPERATING_TOURS_LIST_SUCCESS"
export const GET_OPERATING_TOURS_LIST_ERROR="GET_OPERATING_TOURS_LIST_ERROR"

export const GET_OPERATING_TOUR_LEADS_LIST_START="GET_OPERATING_TOUR_LEADS_LIST_START"
export const GET_OPERATING_TOUR_LEADS_LIST_SUCCESS="GET_OPERATING_TOUR_LEADS_LIST_SUCCESS"
export const GET_OPERATING_TOUR_LEADS_LIST_ERROR="GET_OPERATING_TOUR_LEADS_LIST_ERROR"